import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import { BubbleSpinLoader } from 'react-css-loaders';
import AskStore from '../stores/AskStore';
import Progress from '../components/Progress';

@observer
export default class Ask extends Component {
  constructor(props) {
    super(props);
    this.state = { productId: '', questionText: '' };
  }

  componentWillMount() {
		AskStore.fetchData();
	}

  handleSubmit(event) {
		event.preventDefault();
    const { productId, questionText } = this.state;
    AskStore.send(productId, questionText, () => this.setState( { productId: '', questionText: '' } ));
	}

  render() {
    return (
      <section id="content-ask" className="content">
        { AskStore.isSending &&
          <div>
            <Progress/>

            <section className="container-loader">
              <BubbleSpinLoader color="#aaa" size={5}/>
            </section>
          </div>
        }

        <div className={ AskStore.isSuccess ? 'container-success active' : 'container-success' }>
					<div className="success">
						<img src={require("../img/icon-correct.svg")}/>

						<h4>Dúvida enviada com sucesso!</h4>
            <span>Você será respondido em breve!</span>
					</div>
				</div>

        { AskStore.loading &&
          <section className="container-loader">
            <BubbleSpinLoader color="#aaa" size={5}/>
          </section>
        }

        { !AskStore.loading &&
          <div>
            <h4>Esclareça suas dúvidas fazendo uma pergunta para o Gerente de Produto:</h4>

            <form onSubmit={this.handleSubmit.bind(this)}>
              { AskStore.products.length > 0 &&
                <p>
                  <select id="select-product" name="select-product"
                    value={this.state.productId}
                    onChange={(ev) => this.setState({ productId: ev.target.value })}>
                    <option value="">Selecione um produto</option>

                    {AskStore.products.map((product) => (<option key={product.id} value={product.id}>{product.name}</option>))}
                  </select>
                </p>
              }

              { (this.state.productId || AskStore.products.length == 0) &&
                <p>
                  <label htmlFor="message">Descreva sua dúvida</label>
                  <textarea
                    id="message"
                    name="message"
                    onChange={(ev) => this.setState({ questionText: ev.target.value })}
                    value={this.state.questionText}>
                  </textarea>

                  { this.state.questionText.trim().length > 0 &&
                    <button className={ AskStore.isSending ? 'disabled' : '' }>
                      <img alt="" src={require("../img/icon-message-white.svg")} className="hover"/>
                      <img alt="" src={require("../img/icon-message-green.svg")} className="normal"/>
                    </button>
                  }
                </p>
              }

              { AskStore.errorMessage && (
                <span className="errorMessage">{AskStore.errorMessage}</span>
              )}
            </form>
          </div>
        }
  		</section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Ask.js